import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const CourseLockedLesson = ({ lessonNumber, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.title) },
            "Lesson",
            lessonNumber),
        React.createElement("div", { className: css(styles.iconCircle) },
            React.createElement("img", { className: css(styles.lockIcon), src: "/assets/images/course/lock.png" }))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Colors.White,
        border: `1px solid ${Colors.BorderLightGray}`,
        borderRadius: 10,
        padding: '20px 16px',
        [MediaBreakPointUp.MD]: {
            padding: '20px 20px',
        },
    },
    title: {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '140%',
        letterSpacing: '0.56px',
        color: Colors.GrayDarkest,
    },
    iconCircle: {
        width: 60,
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    lockIcon: {
        width: '100%',
        height: '100%',
    },
});
